module.exports = __webpack_public_path__ + "static/img/15.878edd0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/1/zh/15.png
// module id = WA6k
// module chunks = 0